import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, HostListener, inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../atoms/button/button.component';
import { ButtonSize, ButtonSkin } from '../../../enums/button.enum';
import { Store } from '@ngrx/store';
import { AuthState } from '../../../../core/state/auth/auth.reducer';
import { selectIsLoggedIn } from '../../../../core/state/auth/auth.selectors';
import { logoutBackend } from '../../../../core/state/auth/auth.actions';
import { HeaderItemComponent } from '../../molecules/header-item/header-item.component';
import { MobileSidebarService } from '../../../../core/services/mobile-sidebar.service';
import { IconComponent } from '../../atoms/icon/icon.component';
import { IconSize } from '../../../enums/icon.enum';
import { Observable } from 'rxjs';
import { selectIsAdmin, selectIsAdminOrModerator, selectIsChef, selectUser } from '../../../../core/state/user/user.selectors';
import { LanguageSelectorComponent } from '../../molecules/language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  imports: [CommonModule, ButtonComponent, HeaderItemComponent, IconComponent, LanguageSelectorComponent, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  public ButtonSkin: typeof ButtonSkin = ButtonSkin;
  public ButtonSize: typeof ButtonSize = ButtonSize;
  public IconSize: typeof IconSize = IconSize;
  public isAdmin$: Observable<boolean>;
  public isAdminOrModerator$: Observable<boolean>;
  public isChef$: Observable<boolean>;
  private store = inject(Store<AuthState>);
  isLoggedIn = computed(() => this.store.selectSignal(selectIsLoggedIn)());
  isLoggedInUser = computed(() => this.store.selectSignal(selectUser)());
  isDropdownOpen = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(private router: Router, private authStore: Store<AuthState>, private mobileSidebar: MobileSidebarService) {}

  ngOnInit() {
    this.isAdmin$ = this.authStore.select(selectIsAdmin);
    this.isAdminOrModerator$ = this.authStore.select(selectIsAdminOrModerator);
    this.isChef$ = this.authStore.select(selectIsChef);
  }

  navigateToDownload(): void {
    this.router.navigate(['/download']);
  }

  navigateToMain(): void {
    if (this.isLoggedIn()){
      this.router.navigate(['/meal-planner']);
    } else {
      this.router.navigate(['/']);
    }
  }

  onAvatarClick() {
    if (window.innerWidth <= 1024) {
      this.mobileSidebar.toggle();
    } else {
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  toggleMobileSidebarLoggedOut() {
    if (window.innerWidth <= 1024) {
      this.mobileSidebar.toggle();
    }   
  }

  toggleMobileSidebar() {
    this.toggleSidebar.emit();
  }

  logout(event?: MouseEvent): void {
    event?.stopPropagation();
    this.authStore.dispatch(logoutBackend());
  }

  // Optional: close dropdown on outside click (desktop only)
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    if (window.innerWidth > 1024 && !(event.target as HTMLElement).closest('.header__user-avatar-container')) {
        this.isDropdownOpen = false;
    }
  }

}
